import { usePriceTypeSelector } from '../../../../../../../../hooks/selectors/usePriceTypeSelector';
import { EJsonQueryPriceType } from '../../../../../../../../repositories/common/json_query';

export function useCoworkingPriceTypeSelector(): EJsonQueryPriceType {
  return usePriceTypeSelector() || EJsonQueryPriceType.All;
}
